<template>
  <ListLayout
    :title="`Consignee`"
    :tableData="consigneeList"
    :tableHeader="tableHeaders"
    :total="totalItem"
    @getList="getConsigneeList"
    :context="context"
    ref="listTable"
  >
    <template #listAction>
      <PrimaryButton
        @click="$router.push({ name: 'add-consignee' })"
        color="primary"
        icon="mdi-plus"
        iconSize="lg"
        name="Add Consignee"
      >
      </PrimaryButton>
    </template>
    <template #rightFilterSlot>
      <div class="d-flex align-center justify-end w-100">
        <RefreshListButton
          :isIcon="false"
          @click="$refs.listTable.searchTriggered()"
        />
      </div>
    </template>
    <template #dialogs> </template>
  </ListLayout>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { bus } from "@/main.js";
import ConsigneeButton from "@/components/Button/ConsigneeButton.vue";
import ListLayout from "@/components/LayoutComponents/ListLayout.vue";
import RefreshListButton from "@/components/BaseComponents/RefreshListButton.vue";
import { mapState } from "vuex";
import { filterModules } from "@/utils/fieldConstants";
import { userModule } from "@/utils/moduleMapping";

export default {
  components: {
    ConsigneeButton,
    ListLayout,
    RefreshListButton,
  },
  data() {
    return {
      userModule,
      permissions: null,
      sorting: {},
      usersPerPage: 10,
      pageNo: 1,
      totalItem: 0,
      consigneeList: [],
      headerSelected: [
        {
          headerName: "Username",
          field: "username",
          sortable: true,
        },
        {
          headerName: "First Name",
          field: "first_name",
          sortable: true,
        },
        {
          headerName: "Last Name",
          field: "last_name",
          sortable: false,
        },
        {
          headerName: "Email",
          field: "email",
          sortable: false,
        },
        {
          headerName: "Contact Number",
          field: "contact_number",
          sortable: true,
        },
      ],

      isEditing: false,
      showUserForm: false,
      selectedUserID: null,

      showBulkUploadDialog: false,

      isButtonDisabled: false,
      buttonTooltip: "Add Users",
    };
  },
  computed: {
    tableHeaders() {
      return [
        ...this.headerSelected,
        {
          headerName: "Actions",
          field: "actions",
          pinned: "right",
          minWidth: 100,
          sortable: false,
          width: 100,
          cellRenderer: "ConsigneeButton",
        },
      ];
    },
    context() {
      return { parentComponent: this };
    },
  },
  methods: {
    resetFilter() {
      // this.$store.commit("userProfile/resetFilters", {
      //   moduleKey: "normal_user_filters",
      // });
      // this.getConsigneeList({ limit: 10, offset: 0 });
    },
    async getConsigneeList(params = {}) {
      bus.$emit("showLoader", true);
      params = {
        ...params,
        ...this.normalUserFilters,
      };

      if ("ordering" in params && params.ordering.length > 0) {
        params = { ...params, ordering: params.ordering.join(",") };
      }

      // await this.$store.dispatch("userProfile/updateUserFilters", {
      //   filter_data: { ...this.normalUserFilters },
      //   filter_type: filterModules.NORMAL_USER,
      // });

      this.$api.consigneeManagement
        .getConsigneeList(params)
        .then((res) => {
          this.consigneeList = res.data;
          this.totalItem = res.count;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
  },
  created() {
    this.permissions = this.$permissions.getPermission("user");
  },
};
</script>
